import { LayoutName, LayoutNameSchema } from "@monkeytype/schemas/layouts";

export const LayoutsList: LayoutName[] = LayoutNameSchema._def.values;
